import React from 'react';
import { useIntl } from 'react-intl';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { SelectField, Typography } from 'embeds/components';

import { messages } from './messages';
import { styles } from './styles';
import { useViewModel } from './useViewModel';

interface SendAndReceiptWarningProps extends WithStyles<typeof styles> {}

const SenderSelector: React.FC<SendAndReceiptWarningProps> = ({ classes }) => {
  const { formatMessage } = useIntl();
  const { sender, options, setSender, hideSenderSelector } = useViewModel();

  if (hideSenderSelector) {
    return <></>;
  }

  return (
    <div className={classes.senderAndReceiverDiv}>
      {options.length === 1 ? (
        <Typography className={classes.text}>
          {formatMessage(messages.sendAs, {
            sender: options[0].name,
          })}
        </Typography>
      ) : (
        <>
          <Typography className={classes.text}>
            {formatMessage(messages.sendAs, {
              sender: '',
            })}
            :
          </Typography>
          <SelectField
            classes={{ root: classes.selectRoot }}
            name="sender"
            onChange={(value) => setSender(value)}
            value={sender || ''}
            options={options}
            inputClassName={classes.selectInput}
          />
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(SenderSelector);
